module.exports = __webpack_public_path__ + "img/catchphrase-myfunda@3x.95621aad.png";